type EmptyStateProps = {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center rounded-lg bg-background-100 border border-background-200/70">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <p className="text-base md:text-lg font-medium text-foreground-800">{title}</p>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}